import { Button } from "primereact/button";
import { Dropdown, DropdownFilterEvent } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { SyntheticEvent, useEffect, useMemo, useRef, useState } from "react";
import { InputTextarea } from 'primereact/inputtextarea';
import { Checkbox } from "primereact/checkbox";
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Toolbar } from 'primereact/toolbar';
import { Calendar } from "primereact/calendar";
import { Chip } from 'primereact/chip';
import { Controller, useForm } from "react-hook-form";
import { classNames } from 'primereact/utils';
import { Toast } from 'primereact/toast';
import { Divider } from "primereact/divider";
import { useParams } from "react-router-dom";
import { StyleService } from "../../service/StyleService";
import FullStyle from "../../models/FullStyle";
import { InputNumber } from "primereact/inputnumber";
import StyleType from "../../models/StyleType";
import CodeType from "../../models/CodeType";
import { SetupOptionsService } from "../../service/SetupOptionsService";
import SetupOptionsSize from "../../models/SetupOptionsSize";
import Chart from "../../models/Chart";
import MinGroup from "../../models/MinGroup";
import { useMsal } from "@azure/msal-react";
import MaintenanceService from "../../service/MaintenanceService";
import LetPriceCode from "../../models/LetPriceCode";
import { FormEvent } from "primereact/ts-helpers";
import { msalInstance } from "../../service/msal";
import User from "../../models/User";
import { UserService } from "../../service/UserService";
import { Dialog } from "primereact/dialog";
import Style from "../../models/Style";

interface DropdownItem {
  name: string;
  code: string;
}

const StyleSetup = () => {
  const emptyFullStyle: FullStyle = {
    style_cd: "",
    style_classcd: "",
    style_effdate: '',
    style_discdate: null,
    style_longdesc: "",
    style_price: 0,
    style_cost: null,
    style_sizeopt: null,
    style_szchart: "",
    style_intszchart: "",
    style_lthchart: "",
    style_poschart: "",
    style_arrchart: "",
    style_letavail: "",
    style_garmtype: "",
    style_letprccd: "",
    style_prmptlet1: "",
    style_prmptlet2: "",
    style_prmptlet3: "",
    style_prmptlet4: "",
    style_maxlet1: null,
    style_maxlet2: null,
    style_maxlet3: null,
    style_maxlet4: null,
    style_addlet: "",
    style_plantdoc: "",
    style_indlet: "",
    style_custom: "",
    style_sewon: "",
    style_weight: null,
    style_companyid: null,
    style_upddt: "",
    style_upduser: "",
    style_status: "",
    style_commrt: null,
    style_uom: "",
    style_filler1: "",
    style_filler2: "",
    style_filler3: "",
    style_filler4: "",
    style_saflag: "",
    style_capcat: "",
    style_schedgrp: "",
    style_szcd: "",
    style_obsolete: "",
    style_letsort: "",
    style_letedit: "",
    style_speccom1: "",
    style_speccom2: "",
    style_catcenyr: null,
    style_catpage: "",
    style_catpict: "",
    style_catbrand: "",
    style_vendnum: null,
    style_webitem: "",
    style_minletwth: null,
    style_maxletwth: null,
    style_cmpletcap: "",
    style_sewfilereq: "",
    style_minqty: null,
    style_splitqtyflag: "",
    style_mingroupid: null,
    style_altstylecd: "",
    style_reqstyle: "",
    style_basestyle: "",
    style_childstyle: "",
    style_bkimage: "",
    style_frimage: "",
    style_chgfreight: null,
    style_clothing: null,
    style_footwear: null,
    style_everydaywear: null,
    style_letnumclr: null,
    style_timstp: "",
    style_fillinorder: null,
    style_fanwear: null,
    style_styletypecd: null,
    style_baseltrstyle: null,
    style_updts: "",
    style_ythspec: null,
    style_adultspec: null,
    style_ythpattern: null,
    style_adultpattern: null,
    style_taxtype: null,
    style_maxindlet: null,
    style_paynow: false,
    style_materialtype: "",
    style_materialgroup: "",
    style_product_hierarchy1: "",
    style_product_hierarchy2: "",
    style_product_category: "",
    style_last_update_sap_user: null,
    style_last_update_sap: null,
    style_vdsstock: false,
    style_product_allocation: 0,
    style_stoneminutes: null,
    style_braidminutes: null,
    style_sewminutes: null,
    style_createminutes: null,
    style_applyminutes: null,
    style_totalsam: null,
    style_product_hierarchy3: "",
    style_subpressminutes: null,
    style_subprintminutes: null,
    style_createddate: null,
    style_validfromdate: null,
    stylecom_catcom: '',
    stylecom_intcom: '',
    stylecom_stycom: '',
    mgdescription: '',
    company_name: '',
    pcatdesc: '',
    phier1desc: '',
    phier2desc: '',
    phier3desc: ''
  };

  const [styleSetup, setStyleSetup] = useState<FullStyle>(emptyFullStyle);
  const [defaultStyleSetup, setDefaultStyleSetup] = useState<FullStyle>(emptyFullStyle);
  const [styleGarType, setStyleGarType] = useState<CodeType[]>();
  const [styleTaxType, setStyleTaxType] = useState<CodeType[]>();
  const [stylePosType, setStylePosType] = useState<Chart[]>();
  const [styleArrType, setStyleArrType] = useState<Chart[]>();
  const [styleSizeType, setStyleSizeType] = useState<Chart[]>();
  const [styleIntSizeType, setStyleIntSizeType] = useState<Chart[]>();
  const [styleSetupSize, setStyleSetupSize] = useState<SetupOptionsSize[]>();
  const [styleMinGroup, setStyleMinGroup] = useState<MinGroup[]>();
  const [stylePriceCode, setStylePriceCode] = useState<LetPriceCode[]>();

  const [styleMaterialType, setStyleMaterialType] = useState<CodeType[]>();
  const [styleType, setStyleType] = useState<StyleType[]>();

  const [checkedCustom, setCheckedCustom] = useState(false);
  const [checkedFanwear, setCheckedFanwear] = useState(false);
  const [checkedReqAddVch, setCheckedReqAddVch] = useState(false);
  const [checkedPrintPltDocs, setCheckedPrintPltDocs] = useState(false);
  const [checkedColOnCol, setCheckedColOnCol] = useState(false);
  const [checkedFillInOrder, setCheckedFillInOrder] = useState(false);
  const [checkedVDSStock, setCheckedVDSStock] = useState(false);
  const [checkedChgFreight, setCheckedChgFreight] = useState(false);
  const [checkedSplitQty, setCheckedSplitQty] = useState(false);
  const [checkedAllowSewOn, setCheckedAllowSewOn] = useState(false);
  const [checkedWebItem, setCheckedWebItem] = useState(false);
  const [checkedAddLet, setCheckedAddLet] = useState(false);
  const [checkedBaseStyle, setCheckedBaseStyle] = useState(false);

  const [user, setUser] = useState<User>();
  const [copyFromVisible, setCopyFromVisible] = useState(false);
  const [styles, setStyles] = useState<Style[]>([]);
  const [styleSelected, setStyleSelected] = useState<string | null>(null);

  const toast = useRef<any>(null);
  const [activeIndex, setActiveIndex] = useState<number | number[]>();
  const [checkedExpanded, setCheckedExpanded] = useState(false);
  const { handleSubmit, control, formState } = useForm();
  const errors = formState.errors;
  const { styleCode } = useParams();
  const { accounts } = useMsal();
  const account = msalInstance.getActiveAccount();
  
  useEffect(() => {
    if (!styleCode) { return; }

    StyleService.getStyleSetup(styleCode).then((res) => {
      setStyleSetup(res);
      setDefaultStyleSetup(res);
    });

    StyleService.getListStyleGarType().then((res) => {
      setStyleGarType(res);
    });

    StyleService.getListTaxType().then((res) => {
      setStyleTaxType(res);
    });

    StyleService.getListMaterialType().then((res) => {
      setStyleMaterialType(res);
    });

    StyleService.getListStyleType().then((res) => {
      setStyleType(res);
    });

    StyleService.getListPosChartType().then((res) => {
      setStylePosType(res);
    });

    StyleService.getListArrChartType().then((res) => {
      setStyleArrType(res);
    });

    StyleService.getListSizeChartType().then((res) => {
      setStyleSizeType(res);
    });

    SetupOptionsService.getSetupOptionsSizes().then((res) => {
      setStyleSetupSize(res);
    });

    StyleService.getListIntSizeChartType().then((res) => {
      setStyleIntSizeType(res);
    });

    MaintenanceService.getMinGroups().then((res) => {
      setStyleMinGroup(res);
    });

    MaintenanceService.getLetPriceCds().then((res) => {
      setStylePriceCode(res);
    });

    if (account !== undefined && account !== null && account.name !== undefined) {
      let firstName = account?.name?.split(' ')[0];
      let lastName = account?.name?.split(' ')[1];
      UserService.getUser(firstName, lastName).then(data => {
          setUser(data);});
    }
  }, [styleCode]);

  useEffect(() => {
    console.log(styleSetup);
    setCheckedCustom(styleSetup.style_custom === 'Y' ? true : false);
    setCheckedFanwear(styleSetup.style_fanwear === 'Y' ? true : false);
    setCheckedFillInOrder(styleSetup.style_fillinorder === 'Y' ? true : false);
    setCheckedVDSStock(styleSetup.style_vdsstock);
    setCheckedChgFreight(styleSetup.style_chgfreight === 'Y' ? true : false);
    setCheckedSplitQty(styleSetup.style_splitqtyflag === 'Y' ? true : false);
    setCheckedAllowSewOn(styleSetup.style_sewon === 'Y' ? true : false);
    setCheckedWebItem(styleSetup.style_webitem === 'Y' ? true : false);
    setCheckedAddLet(styleSetup.style_addlet === 'Y' ? true : false);
    setCheckedColOnCol(styleSetup.style_filler1 === 'Y' ? true : false)
    setCheckedPrintPltDocs(styleSetup.style_plantdoc === 'Y' ? true : false);
    setCheckedReqAddVch(styleSetup.style_reqstyle === 'Y' ? true : false);
    setCheckedBaseStyle(styleSetup.style_basestyle === 'Y' ? true : false);
  }, [styleSetup]);

  const revertDefaultStyleSetup = () => {
    setStyleSetup(defaultStyleSetup);
  }

  const ltrAllowed: DropdownItem[] = useMemo(
    () => [
      { name: '', code: '' },
      { name: 'Team', code: 'T' },
      { name: 'None', code: 'N' },
      { name: 'All', code: 'A' }
    ],
    []
  );

  const lettype: DropdownItem[] = useMemo(
    () => [
      { name: '', code: '' },
      { name: 'Individual', code: 'I' },
      { name: 'Team', code: 'T' }
    ],
    []
  );

  const promptWrd: DropdownItem[] = useMemo(
    () => [
      { name: 'Count Only', code: '' },
      { name: 'Word', code: 'Y' },
      { name: 'Closed', code: 'N' }
    ],
    []
  );

  const toolbarLeftTemplate = () => {
    return (
      <>
        <Button icon="pi pi-bars" outlined size="small" type="button" className="mr-4"
          onClick={() => {
            if (checkedExpanded) {
              setActiveIndex([]);
            } else {
              setActiveIndex([0, 1, 2, 3, 4]);
            }
            setCheckedExpanded(!checkedExpanded);
          }} />
      </>
    );
  };

  const formatDate = (strDate: string | null) => {
    const date = strDate ? new Date(strDate) : null;
    const formattedDate = date ? `${date.toLocaleDateString()} ${date.toLocaleTimeString()}` : 'N/A';
    return formattedDate;
  }

  const toolbarRightTemplate = () => {
    return (
      <>
        <div className="flex align-items-center flex-wrap gap-1 mr-5">
          <Chip style={{ fontWeight: 'bold' }} label={`SAP Created Date: ${formatDate(styleSetup.style_createddate)}`} icon="pi pi-sync" />
          <Chip style={{ fontWeight: 'bold' }} label={`Last SAP Update: ${styleSetup.style_last_update_sap_user && styleSetup.style_last_update_sap_user.trim().length > 0 ? styleSetup.style_last_update_sap_user + ' on ' : ''} ${formatDate(styleSetup.style_last_update_sap)}`} icon="pi pi-sync" />
          <Chip style={{ fontWeight: 'bold' }} label={`Last Update: ${styleSetup.style_upduser.trim().length > 0 ? styleSetup.style_upduser + ' on ' : ''} ${formatDate(styleSetup.style_upddt)}`} icon="pi pi-sync" />
        </div>
        <Button icon="pi pi-save" size="small" outlined severity="success" label="Save" type="submit" style={{ marginRight: '.5em' }} />
        <Button icon="pi pi-undo" size="small" outlined severity="danger" label="Undo" type="button" onClick={revertDefaultStyleSetup} style={{ marginRight: '.5em' }} />
        {user?.canAddEditStyles && <Button icon="pi pi-copy" size="small" outlined severity="info" label="Copy From" type="button" style={{ marginRight: '.5em' }} onClick={() => { findStyles("1"); setCopyFromVisible(true); }} />}
      </>
    );
  };

  const save = async (value: FullStyle): Promise<FullStyle | null> => {
    if (!value) { return null; }
    try {
      const data = await StyleService.updateStyleSetup(value);
      if (data) {
        toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Style Setup Updated', life: 3000 });
        return data;
      } else {
        toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed updating Style Setup', life: 3000 });
        return null;
      }
    } catch (error) {
      toast.current.show({ severity: 'error', summary: 'Exception', detail: 'An exception occurred while updating Style Setup', life: 3000 });
      return null;
    }
  };

  const invalidToast = (value: number | null) => {
    if (value && (value < 0 || value > 99.99)) {
      toast.current.show({
        severity: 'error',
        summary: 'Invalid Input',
        detail: 'Value must be between 0 and 99',
        life: 5000
      });
    }
  }
  const onSubmit = async () => {
    let _styleSetup = { ...styleSetup };
    _styleSetup.style_mingroupid = _styleSetup.style_mingroupid ?? 0;
    _styleSetup.style_garmtype = _styleSetup.style_garmtype ?? '';
    _styleSetup.style_styletypecd = _styleSetup.style_styletypecd ?? null;
    _styleSetup.style_sizeopt = _styleSetup.style_sizeopt ?? 0;
    _styleSetup.style_szchart = _styleSetup.style_szchart ?? '';
    _styleSetup.style_intszchart = _styleSetup.style_intszchart ?? '';
    _styleSetup.style_letavail = _styleSetup.style_letavail ?? '';
    _styleSetup.style_poschart = _styleSetup.style_poschart ?? '';
    _styleSetup.style_arrchart = _styleSetup.style_arrchart ?? '';
    _styleSetup.style_indlet = _styleSetup.style_indlet ?? '';
    _styleSetup.stylecom_catcom = _styleSetup.stylecom_catcom ?? '';
    _styleSetup.stylecom_stycom = _styleSetup.stylecom_stycom ?? '';
    _styleSetup.stylecom_intcom = _styleSetup.stylecom_intcom ?? '';

    if (accounts[0]) {
      _styleSetup.style_upddt = new Date().toISOString();
      _styleSetup.style_upduser = accounts[0].username.split('@')[0];
    }

    let res = await save(_styleSetup);
    if (res) {
      setStyleSetup(res);
    }
  };

  const getFormErrorMessage = (name: string) => {
    return errors[name] ? <small className="p-error">{(errors[name] as any).message}</small> : <small className="p-error">&nbsp;</small>;
  };

  const styleCodeTypeTemplate = (option: CodeType) => {
    return (
      <div className="flex align-items-center">
        <div>{option.codeId} - {option.codeDesc}</div>
      </div>
    );
  };

  const selectedStyleCodeTypeTemplate = (option: CodeType, props: any) => {
    if (option) {
      return (
        <div className="flex align-items-center">
          <div>{option.codeId} - {option.codeDesc}</div>
        </div>
      );
    }

    return <span>{props.placeholder}</span>;
  };

  const styleChartTypeTemplate = (option: Chart) => {
    return (option.chartCd + ' - ' + option.chartDesc);
  };

  const selectedStyleChartTypeTemplate = (option: Chart, props: any) => {
    if (option) {
      return (option.chartCd + ' - ' + option.chartDesc);
    }

    return <span>{props.placeholder}</span>;
  };

  const styleDropdownTypeTemplate = (option: DropdownItem) => {
    return (option.code + ' - ' + option.name);
  };

  const selectedStyleDropdownTypeTemplate = (option: DropdownItem, props: any) => {
    if (option) {
      return (option.code + ' - ' + option.name);
    }

    return <span>{props.placeholder}</span>;
  };

  const stylePriceTypeTemplate = (option: LetPriceCode) => {
    return (
      <div className="flex align-items-center">
        <div>{option.letPriceCdCd} - {option.letPriceCdDesc}</div>
      </div>
    );
  };

  const selectedStylePriceTypeTemplate = (option: LetPriceCode, props: any) => {
    if (option) {
      return (
        <div className="flex align-items-center">
          <div>{option.letPriceCdCd} - {option.letPriceCdDesc}</div>
        </div>
      );
    }

    return <span>{props.placeholder}</span>;
  };

  const filterStyles = (event: DropdownFilterEvent) => {
    findStyles(event.filter);
  }

  const findStyles = (query: string) => {
    if (query.trim().length === 0) {
      StyleService.getListStylesByName('1').then(data => {
        setStyles(data);
      });
    } else {
      StyleService.getListStylesByName(query).then(data => {
        if (data.length === 0) {
          return false;
        } else {
          setStyles(data);
        }
      });
    }
  };

  const copy = () => {
    if (styleCode && styleSelected) {
      StyleService.copyStyleFrom(styleCode, styleSelected, user?.userId ?? '').then((data) => {
        if(data){
          toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Style copied successfully', life: 3000 });
          setCopyFromVisible(false);
        }
      });
    }      
  };

  const hideDialog = () => {
    setCopyFromVisible(false);
  };

  const dialogFooter = (
    <>
        <Button label="Cancel" icon="pi pi-times" className="p-button-text" onClick={() => { hideDialog(); setStyleSelected(null); }} />
        <Button label="Copy" icon="pi pi-check" className="p-button-text" onClick={copy} />
    </>
  );

  const itemTemplate = (item: Style) => {
    return (
        <div className="flex align-items-center">
            <div>{item.styleCode} - {item.description}</div>
        </div>
    );
  };

  return (
    <div className="grid">
      <Toast ref={toast} />

      <form onSubmit={handleSubmit(onSubmit)} className="col-12">
        <div className="col-12">
          <Toolbar start={toolbarLeftTemplate} end={toolbarRightTemplate}></Toolbar>
        </div>
        <div className="col-12">
          <Accordion multiple activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
            <AccordionTab header="General">
              <div className="grid p-fluid">
                <div className="col-12 md:col-2">
                  <Controller
                    name="style_cd"
                    control={control}
                    defaultValue={styleSetup.style_cd}
                    render={({ field, fieldState }) => (
                      <>
                        <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Item #</label>
                        <InputText id={field.name} disabled value={styleSetup.style_cd} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => { field.onChange(e.target.value); setStyleSetup(prevState => ({ ...prevState, style_cd: e.target.value })); }} />
                        {styleSetup.style_longdesc !== null ? <small className="text-primary">{styleSetup.style_longdesc}</small> : <></>}
                        {getFormErrorMessage(field.name)}
                      </>
                    )}
                  />
                </div>
                <div className="col-12 md:col-2">
                  <Controller
                    name="company_name"
                    control={control}
                    render={({ field, fieldState }) => (
                      <>
                        <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Company</label>
                        <InputText id={field.name} disabled value={styleSetup.company_name} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => { field.onChange(e.target.value); setStyleSetup(prevState => ({ ...prevState, company_name: e.target.value })); }} />
                        {getFormErrorMessage(field.name)}
                      </>
                    )}
                  />
                </div>
                <div className="col-12 md:col-2">
                  <Controller
                    name="style_materialgroup"
                    control={control}
                    render={({ field, fieldState }) => (
                      <>
                        <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Material Group</label>
                        <InputText id={field.name} disabled value={styleSetup.style_materialgroup} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => { field.onChange(e.target.value); setStyleSetup(prevState => ({ ...prevState, style_materialgroup: e.target.value })); }} />
                        {styleSetup.mgdescription !== null ? <small className="text-primary">{styleSetup.mgdescription}</small> : <></>}
                        {getFormErrorMessage(field.name)}
                      </>
                    )}
                  />
                </div>
                <div className="col-12 md:col-2">
                  <Controller
                    name="style_catbrand"
                    control={control}
                    render={({ field, fieldState }) => (
                      <>
                        <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Brand</label>
                        <InputText id={field.name} disabled value={styleSetup.style_catbrand} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => { field.onChange(e.target.value); setStyleSetup(prevState => ({ ...prevState, style_catbrand: e.target.value })); }} />
                        {getFormErrorMessage(field.name)}
                      </>
                    )}
                  />
                </div>
                <div className="col-12 md:col-2">
                  <Controller
                    name="style_catcenyr"
                    control={control}
                    render={({ field, fieldState }) => (
                      <>
                        <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Catalog Year</label>
                        <InputNumber id={field.name} useGrouping={false} disabled value={styleSetup.style_catcenyr} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => { field.onChange(e.value); setStyleSetup(prevState => ({ ...prevState, style_catcenyr: e.value })); }} />
                        {getFormErrorMessage(field.name)}
                      </>
                    )}
                  />
                </div>
                <div className="col-12 md:col-2">
                  <Controller
                    name="style_catpage"
                    control={control}
                    render={({ field, fieldState }) => (
                      <>
                        <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Catalog Page</label>
                        <InputText id={field.name} disabled value={styleSetup.style_catpage} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => { field.onChange(e.target.value); setStyleSetup(prevState => ({ ...prevState, style_catpage: e.target.value })); }} />
                        {getFormErrorMessage(field.name)}
                      </>
                    )}
                  />
                </div>
                <div className="col-12 md:col-2">
                  <Controller
                    name="style_catpict"
                    control={control}
                    render={({ field, fieldState }) => (
                      <>
                        <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Catalog Picture</label>
                        <InputText id={field.name} disabled value={styleSetup.style_catpict} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => { field.onChange(e.target.value); setStyleSetup(prevState => ({ ...prevState, style_catpict: e.target.value })); }} />
                        {getFormErrorMessage(field.name)}
                      </>
                    )}
                  />
                </div>
                <div className="col-12 md:col-2">
                  <Controller
                    name="style_effdate"
                    control={control}
                    render={({ field, fieldState }) => (
                      <>
                        <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Eff Date</label>
                        <Calendar id={field.name} name={field.name} showIcon showButtonBar value={styleSetup.style_effdate ? new Date(styleSetup.style_effdate) : null} inputClassName={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e: FormEvent<Date, SyntheticEvent<Element, Event>>) => { console.log(e.target.value); field.onChange(e.target.value); setStyleSetup(prevState => ({ ...prevState, style_effdate: e.target.value instanceof Date ? e.target.value.toISOString() : '' })); }} dateFormat="yy-mm-dd" />
                        {getFormErrorMessage(field.name)}
                      </>
                    )}
                  />
                </div>
                <div className="col-12 md:col-2">
                  <Controller
                    name="style_discdate"
                    control={control}
                    render={({ field, fieldState }) => (
                      <>
                        <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Dis Date</label>
                        <Calendar id={field.name} name={field.name} disabled showIcon showButtonBar value={styleSetup.style_discdate ? new Date(styleSetup.style_discdate) : null} inputClassName={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e: FormEvent<Date, SyntheticEvent<Element, Event>>) => { field.onChange(e.target.value); }} dateFormat="yy-mm-dd" />
                        {getFormErrorMessage(field.name)}
                      </>
                    )}
                  />
                </div>
                <Divider />
                <div className="col-12 md:col-6">
                  <Controller
                    name="stylecom_stycom"
                    control={control}
                    rules={{
                      maxLength: {
                        value: 500,
                        message: 'Must be at most 500 characters.',
                      },
                    }}
                    render={({ field, fieldState }) => (
                      <>
                        <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Style Comment</label>
                        <InputText id={field.name} value={styleSetup.stylecom_stycom || ''} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => { field.onChange(e.target.value); setStyleSetup(prevState => ({ ...prevState, stylecom_stycom: e.target.value })); }} />
                        {getFormErrorMessage(field.name)}
                      </>
                    )}
                  />
                </div>
                <div className="col-12 md:col-6">
                  <Controller
                    name="stylecom_intcom"
                    control={control}
                    rules={{
                      maxLength: {
                        value: 500,
                        message: 'Must be at most 500 characters.',
                      },
                    }}
                    render={({ field, fieldState }) => (
                      <>
                        <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Internal Comment</label>
                        <InputText id={field.name} value={styleSetup.stylecom_intcom || ''} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => { field.onChange(e.target.value); setStyleSetup(prevState => ({ ...prevState, stylecom_intcom: e.target.value })); }} />
                        {getFormErrorMessage(field.name)}
                      </>
                    )}
                  />
                </div>
                <Divider />
                <div className="flex align-items-center flex-wrap gap-1 mr-5">
                  <Chip style={{ backgroundColor: 'rgba(109, 181, 213, 0.68)', fontWeight: 'bold', padding: '2px 15px 2px 15px' }} icon="pi pi-info-circle" label={`Op Category: ${styleSetup.style_product_category.trim().length > 0 ? styleSetup.style_product_category + ' - ' : 'N/A'} ${styleSetup.pcatdesc ? styleSetup.pcatdesc : ''}`} />
                  <Chip style={{ backgroundColor: 'rgba(207, 213, 109, 0.68)', fontWeight: 'bold', padding: '2px 15px 2px 15px' }} icon="pi pi-database" label={`Allocation: ${styleSetup.style_product_allocation ? styleSetup.style_product_allocation : 0}`} />
                  <Chip style={{ backgroundColor: 'rgba(109, 213, 119, 0.68)', fontWeight: 'bold', padding: '2px 15px 2px 15px' }} icon="pi pi-sitemap" label={`Hierarchy 1: ${styleSetup.style_product_hierarchy1.trim().length > 0 ? styleSetup.style_product_hierarchy1 + ' - ' : 'N/A'} ${styleSetup.phier1desc ? styleSetup.phier1desc : ''}`} />
                  <Chip style={{ backgroundColor: 'rgba(109, 213, 119, 0.68)', fontWeight: 'bold', padding: '2px 15px 2px 15px' }} icon="pi pi-sitemap" label={`Hierarchy 2: ${styleSetup.style_product_hierarchy2.trim().length > 0 ? styleSetup.style_product_hierarchy2 + ' - ' : 'N/A'} ${styleSetup.phier2desc ? styleSetup.phier2desc : ''}`} />
                  <Chip style={{ backgroundColor: 'rgba(109, 213, 119, 0.68)', fontWeight: 'bold', padding: '2px 15px 2px 15px' }} icon="pi pi-sitemap" label={`Hierarchy 3: ${styleSetup.style_product_hierarchy3.trim().length > 0 ? styleSetup.style_product_hierarchy3 + ' - ' : 'N/A'} ${styleSetup.phier3desc ? styleSetup.phier3desc : ''}`} />
                  <Chip style={{ backgroundColor: 'rgba(213, 164, 109, 0.68)', fontWeight: 'bold', padding: '2px 15px 2px 15px' }} icon="pi pi-hashtag" label={`Units Of Measure: ${styleSetup.style_uom.trim().length > 0 ? styleSetup.style_uom : 'N/A'}`} />
                  <Chip style={{ backgroundColor: 'rgba(213, 109, 109, 0.56)', fontWeight: 'bold', padding: '2px 15px 2px 15px' }} icon="pi pi-info-circle" label={`Material Status: ${styleSetup.style_status.trim().length > 0 ? styleSetup.style_status + ' on ' : ''} ${formatDate(styleSetup.style_validfromdate)}`} />
                </div>
              </div>
            </AccordionTab>
            <AccordionTab header="Style & Pricing">
              <div className="grid">
                <div className="col-12 md:col-6">
                  <div className="p-fluid">
                    <h5>Style</h5>
                    <div className="col-12 md:col-12">
                      <Controller
                        name="style_garmtype"
                        control={control}
                        render={({ field, fieldState }) => (
                          <>
                            <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Style Type</label>
                            <Dropdown inputId={field.name} showClear value={styleSetup.style_garmtype} options={styleGarType} optionLabel="codeDesc" optionValue="codeId" className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                              onChange={(e) => { field.onChange(e.value); setStyleSetup(prevState => ({ ...prevState, style_garmtype: e.value })); }} itemTemplate={styleCodeTypeTemplate} valueTemplate={selectedStyleCodeTypeTemplate} placeholder="Select..." />
                            {getFormErrorMessage(field.name)}
                          </>
                        )}
                      />
                    </div>
                    <Divider style={{ 'marginTop': '-5px' }} />
                    <div className="col-12 flex flex-wrap justify-content-start gap-3">
                      <div className="flex align-items-center">
                        <Checkbox inputId="style_custom" onChange={e => { setCheckedCustom(e.checked ?? false); setStyleSetup(prevState => ({ ...prevState, style_custom: e.checked ? 'Y' : 'N' })); }} checked={checkedCustom} />
                        <label htmlFor="style_custom" className="ml-2">Custom</label>
                      </div>
                      <div className="flex align-items-center">
                        <Checkbox inputId="style_fanwear" onChange={e => { setCheckedFanwear(e.checked ?? false); setStyleSetup(prevState => ({ ...prevState, style_fanwear: e.checked ? 'Y' : 'N' })); }} checked={checkedFanwear} />
                        <label htmlFor="style_fanwear" className="ml-2">Fanwear</label>
                      </div>
                      <div className="flex align-items-center">
                        <Checkbox inputId="style_reqstyle" onChange={e => { setCheckedReqAddVch(e.checked ?? false); setStyleSetup(prevState => ({ ...prevState, style_reqstyle: e.checked ? 'Y' : 'N' })); }} checked={checkedReqAddVch} />
                        <label htmlFor="style_reqstyle" className="ml-2">Req. Addl. Vch</label>
                      </div>
                      <div className="flex align-items-center">
                        <Checkbox inputId="style_plantdoc" onChange={e => { setCheckedPrintPltDocs(e.checked ?? false); setStyleSetup(prevState => ({ ...prevState, style_plantdoc: e.checked ? 'Y' : 'N' })); }} checked={checkedPrintPltDocs} />
                        <label htmlFor="style_plantdoc" className="ml-2">Print Plt Docs</label>
                      </div>
                      <div className="flex align-items-center">
                        <Checkbox inputId="style_filler1" onChange={e => { setCheckedColOnCol(e.checked ?? false); setStyleSetup(prevState => ({ ...prevState, style_filler1: e.checked ? 'Y' : 'N' })); }} checked={checkedColOnCol} />
                        <label htmlFor="style_filler1" className="ml-2">Prompt Color on Color</label>
                      </div>
                      <div className="flex align-items-center">
                        <Checkbox inputId="style_fillinorder" onChange={e => { setCheckedFillInOrder(e.checked ?? false); setStyleSetup(prevState => ({ ...prevState, style_fillinorder: e.checked ? 'Y' : 'N' })); }} checked={checkedFillInOrder} />
                        <label htmlFor="style_fillinorder" className="ml-2">Prompt Fill-In order</label>
                      </div>
                      <div className="flex align-items-center">
                        <Checkbox inputId="style_vdsstock" onChange={e => { setCheckedVDSStock(e.checked ?? false); setStyleSetup(prevState => ({ ...prevState, style_vdsstock: e.checked ?? false })); }} checked={checkedVDSStock} />
                        <label htmlFor="style_vdsstock" className="ml-2">Style VDS Stock</label>
                      </div>
                    </div>
                    <Divider />
                    <div className="col-12 md:col-12">
                      <div className="flex align-items-center">
                        <Checkbox inputId="style_webitem" onChange={e => { setCheckedWebItem(e.checked ?? false); setStyleSetup(prevState => ({ ...prevState, style_webitem: e.checked ? 'Y' : 'N' })); }} checked={checkedWebItem} />
                        <label htmlFor="style_webitem" className="ml-2 mr-1">Design Studio Item</label>
                        <Controller
                          name="style_styletypecd"
                          control={control}
                          render={({ field, fieldState }) => (
                            <>
                              <Dropdown inputId={field.name} showClear value={styleSetup.style_styletypecd} options={styleType} disabled={!checkedWebItem} optionLabel="styleTypeCd" optionValue="styleTypeCd" className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                onChange={(e) => { field.onChange(e.value); setStyleSetup(prevState => ({ ...prevState, style_styletypecd: e.value })); }} placeholder="Select..." />
                              {getFormErrorMessage(field.name)}
                            </>
                          )}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 md:col-6">
                  <div className="p-fluid">
                    <h5>Pricing</h5>
                    <div className="grid col-12">
                      <div className="col-12 md:col-2">
                        <Controller
                          name="style_price"
                          control={control}
                          render={({ field, fieldState }) => (
                            <>
                              <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Retail</label>
                              <InputNumber id={field.name} disabled value={styleSetup.style_price} minFractionDigits={2} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => { field.onChange(e.value); setStyleSetup(prevState => ({ ...prevState, style_price: e.value ?? 0 })); }} />
                              {getFormErrorMessage(field.name)}
                            </>
                          )}
                        />
                      </div>
                      <div className="col-12 md:col-8">
                        <Controller
                          name="style_taxtype"
                          control={control}
                          render={({ field, fieldState }) => (
                            <>
                              <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Tax Type</label>
                              <Dropdown inputId={field.name} value={styleSetup.style_taxtype} disabled options={styleTaxType} optionLabel="codeDesc" optionValue="codeId" className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                onChange={(e) => { field.onChange(e.value); setStyleSetup(prevState => ({ ...prevState, style_taxtype: e.value })); }} placeholder="Select..." />
                              {getFormErrorMessage(field.name)}
                            </>
                          )}
                        />
                      </div>
                      <div className="col-12 md:col-2">
                        <Controller
                          name="style_weight"
                          control={control}
                          render={({ field, fieldState }) => (
                            <>
                              <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Weight</label>
                              <InputNumber id={field.name} disabled value={styleSetup.style_weight} minFractionDigits={3} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => { field.onChange(e.value); setStyleSetup(prevState => ({ ...prevState, style_weight: e.value })); }} />
                              {getFormErrorMessage(field.name)}
                            </>
                          )}
                        />
                      </div>
                    </div>
                    <div className="flex flex-wrap justify-content-start gap-3">
                      <div className="flex align-items-center">
                        <Checkbox inputId="style_chgfreight" onChange={e => { setCheckedChgFreight(e.checked ?? false); setStyleSetup(prevState => ({ ...prevState, style_chgfreight: e.checked ? 'Y' : 'N' })); }} checked={checkedChgFreight} />
                        <label htmlFor="style_chgfreight" className="ml-2">Charge freight?</label>
                      </div>
                    </div>
                    <Divider />
                    <Divider />
                    <div className="col-12 md:col-12">
                      <Controller
                        name="style_materialtype"
                        control={control}
                        render={({ field, fieldState }) => (
                          <>
                            <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Material Type</label>
                            <Dropdown inputId={field.name} value={styleSetup.style_materialtype} options={styleMaterialType} optionLabel="codeDesc" optionValue="codeId" className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                              onChange={(e) => { field.onChange(e.value); setStyleSetup(prevState => ({ ...prevState, style_materialtype: e.value })); }} disabled itemTemplate={styleCodeTypeTemplate} valueTemplate={selectedStyleCodeTypeTemplate} placeholder="Select..." />
                            {getFormErrorMessage(field.name)}
                          </>
                        )}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </AccordionTab>
            <AccordionTab header="Quantity & Sizing">
              <div className="grid">
                <div className="col-12 md:col-6">
                  <div className="p-fluid">
                    <h5>Quantity</h5>
                    <div className="grid col-12">
                      <div className="col-12 md:col-2">
                        <Controller
                          name="style_minqty"
                          control={control}
                          rules={{
                            validate: (value) => {
                              if (value < 0 || value > 9999999) {
                                return 'Must be between 0 and 9.999.999';
                              }
                              return true;
                            },
                          }}
                          render={({ field, fieldState }) => (
                            <>
                              <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Min. Qty.</label>
                              <InputNumber id={field.name} value={styleSetup.style_minqty} useGrouping={false} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => { field.onChange(e.value); setStyleSetup(prevState => ({ ...prevState, style_minqty: e.value === null || undefined ? 0 : e.value})); }} />
                              {getFormErrorMessage(field.name)}
                            </>
                          )}
                        />
                      </div>
                      <div className="col-12 md:col-8">
                        <Controller
                          name="style_mingroupid"
                          control={control}
                          render={({ field, fieldState }) => (
                            <>
                              <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Min Grp</label>
                              <Dropdown inputId={field.name} showClear value={styleSetup.style_mingroupid} options={styleMinGroup} optionLabel="minGroupDesc" optionValue="minGroupId" className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                onChange={(e) => { field.onChange(e.value); setStyleSetup(prevState => ({ ...prevState, style_mingroupid: e.value })); }} placeholder="Select..." />
                              {getFormErrorMessage(field.name)}
                            </>
                          )}
                        />
                      </div>
                    </div>
                    <div className="flex flex-wrap justify-content-start gap-3">
                      <div className="flex align-items-center">
                        <Checkbox inputId="style_splitqtyflag" onChange={e => { setCheckedSplitQty(e.checked ?? false); setStyleSetup(prevState => ({ ...prevState, style_splitqtyflag: e.checked ? 'Y' : 'N' })); }} checked={checkedSplitQty} />
                        <label htmlFor="style_splitqtyflag" className="ml-2">Split Qty for Min.</label>
                      </div>
                    </div>
                    <div className="flex flex-wrap justify-content-start gap-3 mt-2">
                      <div className="flex align-items-center">
                        <Checkbox inputId="style_basestyle" onChange={e => { setCheckedBaseStyle(e.checked ?? false); setStyleSetup(prevState => ({ ...prevState, style_basestyle: e.checked ? 'Y' : 'N' })); }} checked={checkedBaseStyle} />
                        <label htmlFor="style_basestyle" className="ml-2">Like Styles/VDS</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 md:col-6">
                  <div className="p-fluid">
                    <h5>Sizing</h5>
                    <div className="grid col-12">
                      <div className="col-12 md:col-6">
                        <Controller
                          name="style_sizeopt"
                          control={control}
                          render={({ field, fieldState }) => (
                            <>
                              <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Size</label>
                              <Dropdown inputId={field.name} filter showClear value={styleSetup.style_sizeopt} virtualScrollerOptions={{ itemSize: 38 }} options={styleSetupSize} optionLabel="size" optionValue="id" className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                onChange={(e) => { field.onChange(e.value); setStyleSetup(prevState => ({ ...prevState, style_sizeopt: e.value })); }} placeholder="Select..." />
                              {getFormErrorMessage(field.name)}
                            </>
                          )}
                        />
                      </div>
                      <div className="col-12 md:col-6">
                        <Controller
                          name="style_szchart"
                          control={control}
                          render={({ field, fieldState }) => (
                            <>
                              <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Size Chart</label>
                              <Dropdown inputId={field.name} filter filterBy="chartCd" showClear value={styleSetup.style_szchart} options={styleSizeType} optionLabel="chartDesc" optionValue="chartCd" className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                onChange={(e) => { field.onChange(e.value); setStyleSetup(prevState => ({ ...prevState, style_szchart: e.value })); }} virtualScrollerOptions={{ itemSize: 38 }} itemTemplate={styleChartTypeTemplate} valueTemplate={selectedStyleChartTypeTemplate} placeholder="Select..." />
                              {getFormErrorMessage(field.name)}
                            </>
                          )}
                        />
                      </div>
                      <div className="col-12 md:col-6">
                        <Controller
                          name="style_intszchart"
                          control={control}
                          render={({ field, fieldState }) => (
                            <>
                              <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Int Size Chart</label>
                              <Dropdown inputId={field.name} filter filterBy="chartCd" showClear value={styleSetup.style_intszchart} options={styleIntSizeType} optionLabel="chartDesc" optionValue="chartCd" className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                onChange={(e) => { field.onChange(e.value); setStyleSetup(prevState => ({ ...prevState, style_intszchart: e.value })); }} virtualScrollerOptions={{ itemSize: 38 }} itemTemplate={styleChartTypeTemplate} valueTemplate={selectedStyleChartTypeTemplate} placeholder="Select..." />
                              {getFormErrorMessage(field.name)}
                            </>
                          )}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </AccordionTab>
            <AccordionTab header="Lettering">
              <div className="grid">
                <div className="col-12 md:col-6">
                  <div className="p-fluid">
                    <h5>Information</h5>
                    <div className="flex flex-wrap justify-content-start gap-3">
                      <div className="flex align-items-center">
                        <Checkbox inputId="style_sewon" onChange={e => { setCheckedAllowSewOn(e.checked ?? false); setStyleSetup(prevState => ({ ...prevState, style_sewon: e.checked ? 'Y' : 'N' })); }} checked={checkedAllowSewOn} />
                        <label htmlFor="style_sewon" className="ml-2">Allow Sew On</label>
                      </div>
                    </div>
                    <div className="grid col-12">
                      <div className="col-12 md:col-4">
                        <Controller
                          name="style_letavail"
                          control={control}
                          render={({ field, fieldState }) => (
                            <>
                              <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Ltr Allowed?</label>
                              <Dropdown inputId={field.name} showClear value={styleSetup.style_letavail} options={ltrAllowed} optionLabel="name" optionValue="code" className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                onChange={(e) => { field.onChange(e.value); setStyleSetup(prevState => ({ ...prevState, style_letavail: e.value })); }} placeholder="Select..." />
                              {getFormErrorMessage(field.name)}
                            </>
                          )}
                        />
                      </div>
                      <div className="col-12 md:col-4">
                        <Controller
                          name="style_poschart"
                          control={control}
                          render={({ field, fieldState }) => (
                            <>
                              <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Pos Chart</label>
                              <Dropdown inputId={field.name} showClear filter filterBy="chartCd" value={styleSetup.style_poschart} options={stylePosType} virtualScrollerOptions={{ itemSize: 38 }} optionLabel="chartDesc" optionValue="chartCd" className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                onChange={(e) => { field.onChange(e.value); setStyleSetup(prevState => ({ ...prevState, style_poschart: e.value })); }} itemTemplate={styleChartTypeTemplate} valueTemplate={selectedStyleChartTypeTemplate} placeholder="Select..." />
                              {getFormErrorMessage(field.name)}
                            </>
                          )}
                        />
                      </div>
                      <div className="col-12 md:col-4">
                        <Controller
                          name="style_arrchart"
                          control={control}
                          render={({ field, fieldState }) => (
                            <>
                              <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Arr Chart</label>
                              <Dropdown inputId={field.name} showClear filter filterBy="chartCd" value={styleSetup.style_arrchart} options={styleArrType} virtualScrollerOptions={{ itemSize: 38 }} optionLabel="chartDesc" optionValue="chartCd" className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                onChange={(e) => { field.onChange(e.value); setStyleSetup(prevState => ({ ...prevState, style_arrchart: e.value })); }} itemTemplate={styleChartTypeTemplate} valueTemplate={selectedStyleChartTypeTemplate} placeholder="Select..." />
                              {getFormErrorMessage(field.name)}
                            </>
                          )}
                        />
                      </div>
                      <div className="col-12 md:col-4">
                        <Controller
                          name="style_minletwth"
                          control={control}
                          render={({ field, fieldState }) => (
                            <>
                              <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Min. Ltr Width</label>
                              <InputNumber id={field.name} value={styleSetup.style_minletwth} max={99.99} minFractionDigits={2} maxFractionDigits={2} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => { field.onChange(e.value); invalidToast(e.value); setStyleSetup(prevState => ({ ...prevState, style_minletwth: e.value === null || undefined ? 0.00 : (e.value >= 0 && e.value <= 99.99 ? e.value : 99.99) })); }} />
                              {getFormErrorMessage(field.name)}
                            </>
                          )}
                        />
                      </div>
                      <div className="col-12 md:col-4">
                        <Controller
                          name="style_maxletwth"
                          control={control}
                          render={({ field, fieldState }) => (
                            <>
                              <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Max. Ltr Width</label>
                              <InputNumber id={field.name} value={styleSetup.style_maxletwth} max={99.99} minFractionDigits={2} maxFractionDigits={2} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => { field.onChange(e.value); invalidToast(e.value); setStyleSetup(prevState => ({ ...prevState, style_maxletwth: e.value === null || undefined ? 0.00 : (e.value >= 0 && e.value <= 99.99 ? e.value : 99.99) })); }} />
                              {getFormErrorMessage(field.name)}
                            </>
                          )}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 md:col-6">
                  <div className="p-fluid">
                    <h5>Lettering Only</h5>
                    <div className="grid col-12">
                      <div className="col-12 md:col-5">
                        <div className="col-12 md:col-12">
                          <Controller
                            name="style_indlet"
                            control={control}
                            render={({ field, fieldState }) => (
                              <>
                                <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Lettering Type</label>
                                <Dropdown inputId={field.name} showClear value={styleSetup.style_indlet} options={lettype} optionLabel="name" optionValue="code" className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                  onChange={(e) => { field.onChange(e.value); setStyleSetup(prevState => ({ ...prevState, style_indlet: e.value })); }} itemTemplate={styleDropdownTypeTemplate} valueTemplate={selectedStyleDropdownTypeTemplate} placeholder="Select..." />
                                {getFormErrorMessage(field.name)}
                              </>
                            )}
                          />
                        </div>
                      </div>
                      <div className="col-12 md:col-6">
                        <div className="col-12 md:col-10">
                          <Controller
                            name="style_letprccd"
                            control={control}
                            render={({ field, fieldState }) => (
                              <>
                                <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Price Code</label>
                                <Dropdown inputId={field.name} value={styleSetup.style_letprccd} options={stylePriceCode} optionLabel="letPriceCdDesc" optionValue="letPriceCdCd" className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                  onChange={(e) => { field.onChange(e.value); setStyleSetup(prevState => ({ ...prevState, style_indlet: e.value })); }} disabled itemTemplate={stylePriceTypeTemplate} valueTemplate={selectedStylePriceTypeTemplate} placeholder="Select..." />
                                {getFormErrorMessage(field.name)}
                              </>
                            )}
                          />
                        </div>
                      </div>
                      <div className="col-12 md:col-5">
                        <div className="col-12 md:col-12">
                          <div className="flex flex-wrap justify-content-start gap-3">
                            <div className="flex align-items-center">
                              <Checkbox inputId="style_addlet" onChange={e => { setCheckedAddLet(e.checked ?? false); setStyleSetup(prevState => ({ ...prevState, style_addlet: e.checked ? 'Y' : 'N' })); }} checked={checkedAddLet} />
                              <label htmlFor="style_addlet" className="ml-2">Count Tail As Additional Letter</label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 md:col-6">
                        <div className="col-12 md:col-10">
                          <Controller
                            name="style_maxindlet"
                            control={control}
                            render={({ field, fieldState }) => (
                              <>
                                <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Max Ind Let</label>
                                <InputNumber id={field.name} value={styleSetup.style_maxindlet} max={99} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => { field.onChange(e.value); invalidToast(e.value); setStyleSetup(prevState => ({ ...prevState, style_maxindlet: e.value === null || undefined ? 0 : (e.value >= 0 && e.value <= 99 ? e.value : 99) })); }} />
                                {getFormErrorMessage(field.name)}
                              </>
                            )}
                          />
                        </div>
                      </div>
                      <div className="col-12 md:col-5">
                        <div className="col-12 md:col-12">
                          <Controller
                            name="style_prmptlet1"
                            control={control}
                            render={({ field, fieldState }) => (
                              <>
                                <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Prompt Wrd 1</label>
                                <Dropdown inputId={field.name} value={styleSetup.style_prmptlet1} options={promptWrd} optionLabel="name" optionValue="code" className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                  onChange={(e) => { field.onChange(e.value); setStyleSetup(prevState => ({ ...prevState, style_prmptlet1: e.value })); }} placeholder="Select..." />
                                {getFormErrorMessage(field.name)}
                              </>
                            )}
                          />
                        </div>
                      </div>
                      <div className="col-12 md:col-6">
                        <div className="col-12 md:col-10">
                          <Controller
                            name="style_maxlet1"
                            control={control}
                            render={({ field, fieldState }) => (
                              <>
                                <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Max # Let 1</label>
                                <InputNumber id={field.name} value={styleSetup.style_maxlet1} max={99} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => { field.onChange(e.value); invalidToast(e.value); setStyleSetup(prevState => ({ ...prevState, style_maxlet1: e.value === null || undefined ? 0 : (e.value >= 0 && e.value <= 99 ? e.value : 99) })); }} />
                                {getFormErrorMessage(field.name)}
                              </>
                            )}
                          />
                        </div>
                      </div>
                      <div className="col-12 md:col-5">
                        <div className="col-12 md:col-12">
                          <Controller
                            name="style_prmptlet2"
                            control={control}
                            render={({ field, fieldState }) => (
                              <>
                                <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Prompt Wrd 2</label>
                                <Dropdown inputId={field.name} value={styleSetup.style_prmptlet2} options={promptWrd} optionLabel="name" optionValue="code" className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                  onChange={(e) => { field.onChange(e.value); setStyleSetup(prevState => ({ ...prevState, style_prmptlet2: e.value })); }} placeholder="Select..." />
                                {getFormErrorMessage(field.name)}
                              </>
                            )}
                          />
                        </div>
                      </div>
                      <div className="col-12 md:col-6">
                        <div className="col-12 md:col-10">
                          <Controller
                            name="style_maxlet2"
                            control={control}
                            render={({ field, fieldState }) => (
                              <>
                                <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Max # Let 2</label>
                                <InputNumber id={field.name} value={styleSetup.style_maxlet2} max={99} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => { field.onChange(e.value); invalidToast(e.value); setStyleSetup(prevState => ({ ...prevState, style_maxlet2: e.value === null || undefined ? 0 : (e.value >= 0 && e.value <= 99 ? e.value : 99) })); }} />
                                {getFormErrorMessage(field.name)}
                              </>
                            )}
                          />
                        </div>
                      </div>
                      <div className="col-12 md:col-5">
                        <div className="col-12 md:col-12">
                          <Controller
                            name="style_prmptlet3"
                            control={control}
                            render={({ field, fieldState }) => (
                              <>
                                <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Prompt Wrd 3</label>
                                <Dropdown inputId={field.name} value={styleSetup.style_prmptlet3} options={promptWrd} optionLabel="name" optionValue="code" className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                  onChange={(e) => { field.onChange(e.value); setStyleSetup(prevState => ({ ...prevState, style_prmptlet3: e.value })); }} placeholder="Select..." />
                                {getFormErrorMessage(field.name)}
                              </>
                            )}
                          />
                        </div>
                      </div>
                      <div className="col-12 md:col-6">
                        <div className="col-12 md:col-10">
                          <Controller
                            name="style_maxlet3"
                            control={control}
                            render={({ field, fieldState }) => (
                              <>
                                <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Max # Let 3</label>
                                <InputNumber id={field.name} value={styleSetup.style_maxlet3} max={99} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => { field.onChange(e.value); invalidToast(e.value); setStyleSetup(prevState => ({ ...prevState, style_maxlet3: e.value === null || undefined ? 0 : (e.value >= 0 && e.value <= 99 ? e.value : 99) })); }} />
                                {getFormErrorMessage(field.name)}
                              </>
                            )}
                          />
                        </div>
                      </div>
                      <div className="col-12 md:col-5">
                        <div className="col-12 md:col-12">
                          <Controller
                            name="style_prmptlet4"
                            control={control}
                            render={({ field, fieldState }) => (
                              <>
                                <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Prompt Wrd 4</label>
                                <Dropdown inputId={field.name} value={styleSetup.style_prmptlet4} options={promptWrd} optionLabel="name" optionValue="code" className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                  onChange={(e) => { field.onChange(e.value); setStyleSetup(prevState => ({ ...prevState, style_prmptlet4: e.value })); }} placeholder="Select..." />
                                {getFormErrorMessage(field.name)}
                              </>
                            )}
                          />
                        </div>
                      </div>
                      <div className="col-12 md:col-6">
                        <div className="col-12 md:col-10">
                          <Controller
                            name="style_maxlet4"
                            control={control}
                            render={({ field, fieldState }) => (
                              <>
                                <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Max # Let 4</label>
                                <InputNumber id={field.name} value={styleSetup.style_maxlet4} max={99} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => { field.onChange(e.value); invalidToast(e.value); setStyleSetup(prevState => ({ ...prevState, style_maxlet4: e.value === null || undefined ? 0 : (e.value >= 0 && e.value <= 99 ? e.value : 99) })); }} />
                                {getFormErrorMessage(field.name)}
                              </>
                            )}
                          />
                        </div>
                      </div>
                      <Divider />
                      <div className="col-12 md:col-5">
                        <div className="col-12 md:col-12">
                          <Controller
                            name="style_letnumclr"
                            control={control}
                            render={({ field, fieldState }) => (
                              <>
                                <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>No. of Colors</label>
                                <Dropdown inputId={field.name} disabled value={styleSetup.style_letnumclr} options={[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]} className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                  onChange={(e) => { field.onChange(e.value); setStyleSetup(prevState => ({ ...prevState, style_letnumclr: e.value })); }} placeholder="Select..." />
                                {getFormErrorMessage(field.name)}
                              </>
                            )}
                          />
                        </div>
                      </div>
                      <div className="col-12 md:col-6">
                        <div className="col-12 md:col-10">
                          <Controller
                            name="style_baseltrstyle"
                            control={control}
                            rules={{
                              maxLength: {
                                value: 18,
                                message: 'Must be at most 18 characters.',
                              },
                            }}
                            render={({ field, fieldState }) => (
                              <>
                                <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Base Lettering Style</label>
                                <InputText id={field.name} value={styleSetup.style_baseltrstyle || ''} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => { field.onChange(e.target.value); setStyleSetup(prevState => ({ ...prevState, style_baseltrstyle: e.target.value })); }} />
                                {getFormErrorMessage(field.name)}
                              </>
                            )}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </AccordionTab>
            <AccordionTab header="Misc">
              <div className="grid p-fluid">
                <div className="col-12 md:col-12">
                  <Controller
                    name="stylecom_catcom"
                    control={control}
                    rules={{
                      maxLength: {
                        value: 1000,
                        message: 'Must be at most 1000 characters.',
                      },
                    }}
                    render={({ field, fieldState }) => (
                      <>
                        <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Catalog Comment</label>
                        <InputTextarea id={field.name} value={styleSetup.stylecom_catcom || ''} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => { field.onChange(e.target.value); setStyleSetup(prevState => ({ ...prevState, stylecom_catcom: e.target.value ?? '' })); }} />
                        {getFormErrorMessage(field.name)}
                      </>
                    )}
                  />
                </div>
                <div className="col-12 md:col-3">
                  <Controller
                    name="style_ythpattern"
                    control={control}
                    rules={{
                      maxLength: {
                        value: 15,
                        message: 'Must be at most 15 characters.',
                      },
                    }}
                    render={({ field, fieldState }) => (
                      <>
                        <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Youth Pattern</label>
                        <InputText id={field.name} value={styleSetup.style_ythpattern || ''} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => { field.onChange(e.target.value); setStyleSetup(prevState => ({ ...prevState, style_ythpattern: e.target.value })); }} />
                        {getFormErrorMessage(field.name)}
                      </>
                    )}
                  />
                </div>
                <div className="col-12 md:col-3">
                  <Controller
                    name="style_ythspec"
                    control={control}
                    render={({ field, fieldState }) => (
                      <>
                        <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Youth Spec</label>
                        <InputNumber id={field.name} value={styleSetup.style_ythspec} max={99.99} minFractionDigits={2} maxFractionDigits={2} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => { field.onChange(e.value); invalidToast(e.value); setStyleSetup(prevState => ({ ...prevState, style_ythspec: e.value === null ? null : (e.value >= 0 && e.value <= 99.99 ? e.value : 99.99) })); }} />
                        {getFormErrorMessage(field.name)}
                      </>
                    )}
                  />
                </div>
                <div className="col-12 md:col-3">
                  <Controller
                    name="style_adultpattern"
                    control={control}
                    rules={{
                      maxLength: {
                        value: 15,
                        message: 'Must be at most 15 characters.',
                      },
                    }}
                    render={({ field, fieldState }) => (
                      <>
                        <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Adult Pattern</label>
                        <InputText id={field.name} value={styleSetup.style_adultpattern || ''} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => { field.onChange(e.target.value); setStyleSetup(prevState => ({ ...prevState, style_adultpattern: e.target.value })); }} />
                        {getFormErrorMessage(field.name)}
                      </>
                    )}
                  />
                </div>
                <div className="col-12 md:col-3">
                  <Controller
                    name="style_adultspec"
                    control={control}
                    render={({ field, fieldState }) => (
                      <>
                        <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Adult Spec</label>
                        <InputNumber id={field.name} value={styleSetup.style_adultspec} max={99.99} minFractionDigits={2} maxFractionDigits={2} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => { field.onChange(e.value); invalidToast(e.value); setStyleSetup(prevState => ({ ...prevState, style_adultspec: e.value === null ? null : (e.value >= 0 && e.value <= 99.99 ? e.value : 99.99) })); }} />
                        {getFormErrorMessage(field.name)}
                      </>
                    )}
                  />
                </div>
              </div>
            </AccordionTab>
          </Accordion>
          <Dialog visible={copyFromVisible} style={{ width: '32rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Copy style from" modal footer={dialogFooter} onHide={hideDialog}>
            <div className="confirmation-content">
              <Dropdown value={styleSelected} options={styles} filter showClear placeholder="Search a style..."
                virtualScrollerOptions={{ itemSize: 38 }} className="w-full" optionLabel="styleCode" itemTemplate={itemTemplate} 
                onFilter={filterStyles} onChange={(e) => {setStyleSelected(e.value);}} />
            </div>
          </Dialog>
        </div>
      </form >

    </div >
  );

};

export default StyleSetup;